class SpinnerService {
  public removeSpinnerOverlay(isPageLoaded: boolean): void {
    const spinnerOverlay = document.getElementById('spinnerOverlay');
    if (isPageLoaded && spinnerOverlay && (window as any).removeElement) {
      (window as any).removeElement('spinnerOverlay');
    }
  }

  public removePlansSkeletonLoader(): void {
    const skeletonLoader = document.querySelector('.product-cards-skeleton-load');
    if (skeletonLoader) {
      setTimeout(() => {
        skeletonLoader.classList.add('product-cards-skeleton-load--plans-almost-loaded');
      }, 500);
      setTimeout(() => {
        skeletonLoader.classList.add('product-cards-skeleton-load--plans-loaded');
      }, 800);
    }
  }

  public showPlansSkeletonLoader(): void {
    const skeletonLoader = document.querySelector('.product-cards-skeleton-load');
    if (skeletonLoader) {
      skeletonLoader.classList.remove('product-cards-skeleton-load--plans-loaded');
      setTimeout(() => {
        skeletonLoader.classList.remove('product-cards-skeleton-load--plans-almost-loaded');
      }, 200);
    }
  }
}

export const spinnerService = new SpinnerService();
